import { useLocation } from 'react-router-dom';

const useFlexLocation = () => {
  const location = useLocation();
  return location;
};

export { useFlexLocation as default };
//# sourceMappingURL=useFlexLocation.mjs.map
